@if (totalPages > 1) {
  <nav  class="pagination" aria-labelledby="pagination">
    <h3 id="pagination" class="sr-only" [innerHTML]="'arialabel.sr.pagination' | translate"></h3>
    <ul >
      <li>
        <button (click)="changePage(currentPage - 1); $event.preventDefault()" class="previous" [class.disabled]="currentPage === 1"
          [attr.aria-label]="'arialabel.prev.page' | translate"  [attr.aria-controls]="ariaControlsTarget">
          <i class="icon-chevron-left"></i>
        </button>
      </li>
      <li>
        @for (page of pages; track page) {
          <button (click)="changePage(page); $event.preventDefault()" [class.active]="page === currentPage"
            [attr.aria-current]="page === currentPage ? page : null" [innerHTML]="page" [attr.aria-controls]="ariaControlsTarget">
          </button>
        }
      </li>
      <li>
        <button (click)="changePage(currentPage + 1); $event.preventDefault()" class="next" [class.disabled]="currentPage === totalPages"
          [attr.aria-label]="'arialabel.next.page' | translate" [attr.aria-controls]="ariaControlsTarget">
          <i class="icon-chevron-right"></i>
        </button>
      </li>
    </ul>
  </nav>
}
